module.exports = __webpack_public_path__ + "static/img/14.02e16cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/14.jpg
// module id = jylW
// module chunks = 0